import APIConfiguration from '@savgroup-front-common/configuration/api';
import { SUPPORTED_METHODS } from '@savgroup-front-common/constants/shared';
import { prepareResponseFailure } from '@savgroup-front-common/core/helpers';
import { apiCall } from '@savgroup-front-common/core/services';
import {
  BackResponseFailure,
  BaseBackResponse,
} from '@savgroup-front-common/types';

interface SetOnboardingWarrantiesCommandArgs {
  sellerId: string;
  diagnosticNeededForUnpackingWarranty: boolean;
  diagnosticNeededForLegalWarrantyOfConformity: boolean;
  isCommercialWithdrawalWarrantyActivated: boolean;
  isExtensionWarrantyActivated: boolean;
  isLegalWarrantyOfConformityActivated: boolean;
  isProWithdrawalWarrantyActivated: boolean;
  isRefundWarrantyActivated: boolean;
  isReturnWarrantyActivated: boolean;
  isStockWarrantyActivated: boolean;
  isSupplierLegalWarrantyOfConformityActivated: boolean;
  isSupplierUnpackingWarrantyActivated: boolean;
  isSwapWarrantyActivated: boolean;
  isTransportWarrantyActivated: boolean;
  isUnpackingWarrantyActivated: boolean;
  isWithdrawalWarrantyActivated: boolean;
  isOutOfWarrantyActivated: boolean;
  commercialWithdrawalWarrantyDuration: {
    unit: string;
    value: string;
  };
  extensionWarrantyDuration: {
    unit: string;
    value: string;
  };
  legalWarrantyOfConformityDuration: {
    unit: string;
    value: string;
  };
  proWithdrawalWarrantyDuration: {
    unit: string;
    value: string;
  };
  refundWarrantyDuration: {
    unit: string;
    value: string;
  };
  returnWarrantyDuration: {
    unit: string;
    value: string;
  };
  stockWarrantyDuration: {
    unit: string;
    value: string;
  };
  supplierLegalWarrantyOfConformityDuration: {
    unit: string;
    value: string;
  };
  supplierUnpackingWarrantyDuration: {
    unit: string;
    value: string;
  };
  swapWarrantyDuration: {
    unit: string;
    value: string;
  };
  transportWarrantyDuration: {
    unit: string;
    value: string;
  };
  unpackingWarrantyDuration: {
    unit: string;
    value: string;
  };
  withdrawalWarrantyDuration: {
    unit: string;
    value: string;
  };
  outOfWarrantyDuration: {
    unit: string;
    value: string;
  };
}

const ENDPOINT = `${APIConfiguration.import}onboardingWarranties`;
const setOnboardingWarrantiesCommand = async (
  payload: SetOnboardingWarrantiesCommandArgs,
): Promise<BaseBackResponse | BackResponseFailure> => {
  try {
    return await apiCall(ENDPOINT, {
      method: SUPPORTED_METHODS.POST,
      json: payload,
    });
  } catch (exception) {
    return prepareResponseFailure(exception);
  }
};

export default setOnboardingWarrantiesCommand;
